import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const addInsuranceClaim = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    '/api/resource/Insurance Claim',
    body
  );
  return data;
});
export const updateInsuranceClaim = catchAsync(async ({ body, id }) => {
  const { data } = await axiosInstance.put(
    `/api/resource/Insurance Claim/${id}`,
    body
  );
  return data;
});
export const deleteInsuranceClaim = catchAsync(async (id) => {
  const { data } = await axiosInstance.delete(
    `/api/resource/Insurance Claim/${id}`
  );
  return data;
});

export const getInsuranceClaim = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/resource/Insurance Claim?fields=["name","insurance_payor","status","patient","insurance_plan","insurance_claim_amount"]'
  );
  return data;
});
export const getInsuranceClaimDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/resource/Insurance Claim/${id}`
  );
  return data;
});
export const getInsuranceClaimFilter = catchAsync(
  async ({
    patient,
    insurance_policy,
    insurance_payor,
    from_date,
    to_date,
  }) => {
    const { data } = await axiosInstance.get(
      `/api/method/technoerp.services.get_coverages?patient=${patient}&insurance_policy=${insurance_policy}&insurance_payor=${insurance_payor}&from_date=${from_date}&to_date=${to_date}`
    );
    return data;
  }
);
